<span
  class="diff-summary-badge badge"
  [ngClass]="{
    'bg-warning text-dark': changeCount > 0,
    'bg-light text-muted border': changeCount === 0,
    'bg-success': isNewService
  }"
  *ngIf="changeCount >= 0">
  <ng-container *ngIf="isNewService">New</ng-container>
  <ng-container *ngIf="!isNewService && changeCount > 0">
    {{ changeCount }} change{{ changeCount > 1 ? 's' : '' }}
  </ng-container>
  <ng-container *ngIf="!isNewService && changeCount === 0">
    No changes
  </ng-container>
</span>
